"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LotState = void 0;
var LotState;
(function (LotState) {
    LotState["DISPOSAL_REQUESTED"] = "DISPOSAL_REQUESTED";
    LotState["DISPOSED"] = "DISPOSED";
    LotState["FULFILLING_ORDERS"] = "FULFILLING_ORDERS";
    LotState["FULFILLMENT_REQUESTED"] = "FULFILLMENT_REQUESTED";
    LotState["QUARANTINED"] = "QUARANTINED";
    LotState["QUARANTINE_REQUESTED"] = "QUARANTINE_REQUESTED";
    LotState["REMOVAL_REQUESTED"] = "REMOVAL_REQUESTED";
    LotState["REMOVED"] = "REMOVED";
    LotState["REVIEW"] = "REVIEW";
    LotState["REVIEW_REQUESTED"] = "REVIEW_REQUESTED";
})(LotState = exports.LotState || (exports.LotState = {}));
//# sourceMappingURL=LotState.js.map